import { toast } from "react-toastify";

/**
 * Extract a human-readable message from RTK Query / fetch AI errors.
 */
export function getAiErrorMessage(error, t) {
  const status = error?.status ?? error?.originalStatus;
  const data = error?.data ?? error;

  if (status === 429) {
    return (
      data?.error ||
      data?.message ||
      t?.("errors.budgetExceeded") ||
      "Monthly AI usage limit reached"
    );
  }
  if (status === 403) {
    return (
      data?.error ||
      data?.message ||
      t?.("errors.notEnrolled") ||
      "You are not enrolled in this course"
    );
  }
  if (status === 422) {
    const raw = data?.error ?? data?.message;
    if (Array.isArray(raw)) return raw.join(", ");
    return raw || t?.("errors.validation") || "Validation error";
  }

  if (Array.isArray(data?.error)) return data.error.join(", ");
  return (
    data?.error ||
    data?.message ||
    error?.message ||
    t?.("errors.generic") ||
    "Something went wrong"
  );
}

export function toastAiError(error, t) {
  toast.error(getAiErrorMessage(error, t));
}
